module.exports = __webpack_public_path__ + "img/Bumper-icon.64e1504d.png";